import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/auth'
import { routes } from './router'

Vue.use(VueRouter)



const router = new VueRouter({
	mode: 'history', // 或 'hash'
	base: process.env.BASE_URL,
	routes,
	scrollBehavior(to, from, savedPosition) {
		// 返回页面滚动位置
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	}
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
	// 如果已经在登录页且有 token，则直接跳转到首页
	if (to.path === '/login') {
		if (getToken()) {
			next({ path: '/' })
			return
		}
	}

	// 设置页面标题
	if (to.meta.title) {
		document.title = to.meta.title
	}

	// 检查是否需要登录
	if (to.matched.some(record => record.meta.requiresAuth)) {
		const token = getToken()
		if (!token) {
			next({
				path: '/login',
				query: { redirect: to.fullPath }
			})
			return
		}
	}
	next()
})

// 路由错误处理
router.onError((error) => {
	const pattern = /Loading chunk (\d)+ failed/g
	const isChunkLoadFailed = error.message.match(pattern)
	if (isChunkLoadFailed) {
		// 处理 chunk 加载失败
		location.reload()
	}
})

// 解决 NavigationDuplicated 错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => {
		// 忽略重复导航和重定向错误，这些通常不影响实际功能
		if (err.name !== 'NavigationDuplicated' && !err.message.includes('Redirected when going from')) {
			throw err
		}
	})
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
	return originalReplace.call(this, location).catch(err => {
		if (err.name !== 'NavigationDuplicated' && !err.message.includes('Redirected when going from')) {
			throw err
		}
	})
}

export default router